import React from 'react';

import {Map} from 'immutable';
import pluralize from 'pluralize';
import Popover from 'material-ui/Popover';

export default class LibrarySearchInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.filterInfoRefs = {};
    this.state = {
      infosHovered: {},
      infosOverflowed: {},
    };
  }

  handleInfoMouseEnter(property) {
    this.setState({infosHovered: {[property]: true}});
  }

  handleInfoMouseExit(property) {
    this.setState({infosHovered: {[property]: false}});
  }

  componentDidUpdate() {
    const infosOverflowed = ['tags', 'callers'].reduce((acc, property) => {
      if (!this.filterInfoRefs[property]) {
        return acc;
      }
      const {offsetWidth, scrollWidth} = this.filterInfoRefs[property];
      return Object.assign({}, acc, {[property]: offsetWidth < scrollWidth});
    }, {});
    if (!Map(infosOverflowed).equals(Map(this.state.infosOverflowed))) {
      this.setState({infosOverflowed});
    }
  }

  render() {
    const {searchInfo} = this.props;
    if (!searchInfo) {
      return null;
    }
    const {tags, library, callers} = searchInfo;
    if (callers.length === 0 && tags.length === 0 && !library) {
      return null;
    }
    const tagsText = tags.join(', ');
    const callersText = callers.map(({label}) => label).join(' or ');
    const hoverItems = [
      ['tags', `${pluralize('Tag', tags.length)}: ${tagsText}`],
      ['callers', `${pluralize('Caller', callers.length)}: ${callersText}`],
    ].map(([property, content], i) => {
      return (
        <div key={i}>
          <Popover
            open={this.state.infosHovered[property] && this.state.infosOverflowed[property]}
            useLayerForClickAway={false}
            anchorEl={this.filterInfoRefs[property]}
            className="search-info-popover"
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}>
            {content}
          </Popover>
          {this.props.searchInfo[property].length <= 0 ? null : (
            <div
              onMouseEnter={() => this.handleInfoMouseEnter(property)}
              onMouseLeave={() => this.handleInfoMouseExit(property)}
              ref={ref => (this.filterInfoRefs[property] = ref)}>
              {content}
            </div>
          )}
        </div>
      );
    });

    return (
      <div className="search-info-container">
        <div className="search-info">
          {library ? <div>Library: {library.name}</div> : null}
          {hoverItems}
        </div>
      </div>
    );
  }
}
